<app-breadcrumb [items]="itemPath()"></app-breadcrumb>

<button
  class="add-item-button"
  mat-fab
  (click)="addNewItem()"
  matTooltip="Add item"
>
  <mat-icon>add</mat-icon>
</button>
<app-tree-root
  #treeRootItem
  [nodes]="displayedTreeNodeItems()"
  [options]="customTemplateOptions"
  (onMovedNode)="onMovedNode($event)"
></app-tree-root>
